import { type Meta } from '../types/docs';

const META: Meta = {
  description: "An author hid or re-showed a sub-page in a collection share link's navigation",
  name: 'subpage_hidden',
  params: [
    {
      description: 'True when the sub-page was hidden, false when it was shown again',
      name: 'hidden',
      required: true,
      type: 'boolean',
    },
  ],
};

export default META;
